/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyExternalOrder from './pharmacy-external-order';
import PharmacyExternalOrderDetail from './pharmacy-external-order-detail';
import PharmacyExternalOrderUpdate from './pharmacy-external-order-update';
import PharmacyExternalOrderDeleteDialog from './pharmacy-external-order-delete-dialog';

const PharmacyExternalOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyExternalOrder />} />
    <Route path="new" element={<PharmacyExternalOrderUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyExternalOrderDetail />} />
      <Route path="edit" element={<PharmacyExternalOrderUpdate />} />
      <Route path="delete" element={<PharmacyExternalOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyExternalOrderRoutes;
